import { FC, useMemo } from 'react'
import styles from 'components/features/future/FutureNetworthBreakdownTable/FutureNetworthBreakdownTable.styl'
import { FutureCategoryBreakDown } from 'components/features/future/types'
import { useStoreSelector } from 'helpers/reactReduxHelpers'
import { metaSelector, getAgeSelector } from 'selectors/globalSelectors'
import { getMetaCategoriesByType } from 'helpers/categoriesHelpers'
import { formatUSCurrency } from 'helpers/formatHelpers'
import cn from 'classnames'
import SvgIcon from 'components/atoms/SvgIcon'
import { FutureColorPicker } from 'components/features/future/FutureColorPicker/FutureColorPicker'

type FutureNetworthBreakdownTableProps = {
  memberValues: FutureCategoryBreakDown[]
  ageDate: string
  type: 'assets' | 'debts'
}

export const FutureNetworthBreakdownTable: FC<FutureNetworthBreakdownTableProps> = (props) => {
  const {
    memberValues,
    ageDate,
    type,
  } = props

  const categoriesMap = useStoreSelector((state) => {
    const meta = metaSelector(state)
    return getMetaCategoriesByType(type, meta).byKey
  })


  const childrenChild = useMemo(() => {
    return memberValues.map(({ category, amount }, index) => {
      const iconSource = require(`icons/${ category }.svg`).default

      return (
        <FutureColorPicker
          key={ category }
          className={ styles.category }
          type={ type }
          index={ index }
        >
          <div className={ styles.title }>
            <div className={ styles.icon }>
              <SvgIcon src={ iconSource } />
            </div>
            { categoriesMap[category].value }
          </div>
          <div className={ styles.amount }>
            { formatUSCurrency(amount) }
          </div>
        </FutureColorPicker>
      )
    })
  }, [memberValues, categoriesMap, type])

  const sum = useMemo(() => {
    return memberValues.reduce((acc, item) => acc + item.amount, 0)
  }, [memberValues])

  const getAge = useStoreSelector(getAgeSelector)

  const ageChild = useMemo(() => {
    if (!getAge) {
      return null
    }

    return (
      <>
        &nbsp;
        <span className={ styles.age }>
          (Age { getAge(ageDate) })
        </span>
      </>
    )
  }, [getAge, ageDate])

  return (
    <FutureColorPicker className={ styles.futureNetworthBreakdownTable } type={ type }>
      <div className={ cn(styles.category, styles.header) }>
        <div className={ styles.title }>
          { type === 'assets' && (
            <>
              Assets { ageChild }
            </>
          )}
          { type === 'debts' && (
            <>
              Debts { ageChild }
            </>
          )}
        </div>
        <div className={ styles.amount }>
          { formatUSCurrency(sum) }
        </div>
      </div>
      { childrenChild }
    </FutureColorPicker>
  )
}
